import { Col, Grid, Image, Row } from "antd";
import { useTranslation } from "react-i18next";
import { H5 } from "../../../../components/NormalFonts";
import { CoachInfoResponse } from "../../../../hooks/Coach/data";
import styles from "./styleModule";

const TeachingMedia = ({ coachInfo }: { coachInfo: CoachInfoResponse }) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const getSpan = () => {
    if (screens.xl) return 6;
    if (screens.md) return 8;
    return 12;
  };

  return (
    <div className={styles.teachingMediaContainer}>
      <H5
        className={`${styles.subTitle} ${screens.md ? "" : styles.mobile}`}
        weight="medium"
        color="var(--primary-90)"
      >
        {t("profile.photo")}
      </H5>
      <Image.PreviewGroup>
        <Row gutter={[12, 24]} style={{ marginBottom: screens.md ? 60 : 40 }}>
          {coachInfo?.teaching_media?.map((photo: string, index: number) => {
            return (
              <Col span={getSpan()} key={`photos_${index}`}>
                <div className={styles.imageWrapper}>
                  <Image
                    src={photo}
                    width={"100%"}
                    height={"100%"}
                    style={{ objectFit: "cover" }}
                  />
                </div>
              </Col>
            );
          })}
        </Row>
      </Image.PreviewGroup>
    </div>
  );
};

export default TeachingMedia;
